/**
 * Legacy-Redirect: /contacts/:id → /people/:id — People-Merge (v2-Relaunch)
 *
 * SPEC.md Global decisions (2026-09-01): "Routes /contacts/* and /hosts/*
 * 301 → /people/*." (siehe layouts/nav.ts, LEGACY_PATH_REDIRECTS). Die
 * eigentliche Person-Detail-Seite (person-detail.html) lebt jetzt unter
 * /people/:id (_auth.people.$id.tsx) und rendert dieselbe ContactDetailPage.
 *
 * Fix (2026-09-01, Abnahme-Runde): vorher rendierte diese Route die
 * ContactDetailPage direkt (Kommentar-Historie siehe git-log) — das ist
 * jetzt die Aufgabe der /people/:id-Route, hier greift nur noch der
 * Redirect wie bei den anderen Legacy-Pfaden.
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/contacts/$id')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/people/$id', params: { id: params.id }, replace: true })
  },
  component: () => null,
})
